"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default={INTEGER:"integer",FLOAT:"float",NUMBER:"number",BOOLEAN:"boolean",STRING:"string"};
//# sourceMappingURL=data-types.js.map
